/**
 * Data Transfer Object for the Signup Step 2 request.
 * This matches the expected format by the backend SignupStep2Request DTO.
 * 
 * The backend expects an array of form fields in the format:
 * { name: string, val: string }
 * 
 * Example usage:
 * 
 * const requestData = {
 *   signUpSecondData: [
 *     { name: "firstname", val: "John" },
 *     { name: "lastname", val: "Doe" },
 *     { name: "headline", val: "Looking for meaningful connections" },
 *     { name: "EDU_BACHELORS", val: "Y" },
 *     { name: "ETH_WHITE_CAUCASIAN", val: "Y" }
 *   ]
 * };
 */

/**
 * Education field mappings
 * When form has dropdown, backend expects specific field names
 */
export const EDUCATION_MAPPINGS = {
    high_school: "EDU_HIGH",
    some_college: "EDU_SOMECOLLEGE",
    associates: "EDU_ASSOC",
    bachelors: "EDU_BACHELORS",
    graduate: "EDU_GRAD",
    doctorate: "EDU_PHD"
  };
  
  /**
   * Ethnicity field mappings
   * When form has dropdown, backend expects specific field names
   */
  export const ETHNICITY_MAPPINGS = {
    asian: "ETH_ASIAN",
    black: "ETH_BLACK",
    latino: "ETH_LATINO_HISPANIC",
    white: "ETH_WHITE_CAUCASIAN",
    middle_eastern: "ETH_MIDDLE_EASTERN",
    native: "ETH_NATIVE_AMERICAN",
    pacific: "ETH_PACIFIC_ISLANDER",
    mixed: "ETH_INTER_RACIAL",
    other: "ETH_OTHER"
  };
  
  /**
   * Helper function to convert form data to the format expected by the backend
   * @param {Object} formData - The form data from React component
   * @returns {Object} - Formatted request DTO for the backend
   */
  export const formatSignupStep2Request = (formData) => {
    const formFields = [
      { name: "firstname", val: formData.firstname },
      { name: "lastname", val: formData.lastname },
      { name: "headline", val: formData.headline }
    ];
    
    // Add education field if selected
    if (formData.education && EDUCATION_MAPPINGS[formData.education]) {
      formFields.push({ 
        name: EDUCATION_MAPPINGS[formData.education], 
        val: "Y" 
      });
    }
    
    // Add ethnicity field if selected
    if (formData.ethnicity && ETHNICITY_MAPPINGS[formData.ethnicity]) {
      formFields.push({ 
        name: ETHNICITY_MAPPINGS[formData.ethnicity], 
        val: "Y" 
      });
    }
    
    return {
      signUpSecondData: formFields
    };
  };
  
  export default {
    EDUCATION_MAPPINGS,
    ETHNICITY_MAPPINGS,
    formatSignupStep2Request
  };